import { request } from 'api';

class SearchApi {
  static getSearchToken() {
    // unauthenticated request
    return request(`search/token`, { method: 'post' });
  }
}

export default SearchApi;
